/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CompanyOfferItem from './CompanyOfferItem';
import Pagination from './Pagination';

/**
 * The CompanyPaginatedOfferItems model module.
 * @module model/CompanyPaginatedOfferItems
 * @version v1
 */
class CompanyPaginatedOfferItems {
    /**
     * Constructs a new <code>CompanyPaginatedOfferItems</code>.
     * Paginated data
     * @alias module:model/CompanyPaginatedOfferItems
     */
    constructor() { 
        
        CompanyPaginatedOfferItems.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CompanyPaginatedOfferItems</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CompanyPaginatedOfferItems} obj Optional instance to populate.
     * @return {module:model/CompanyPaginatedOfferItems} The populated <code>CompanyPaginatedOfferItems</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CompanyPaginatedOfferItems();

            if (data.hasOwnProperty('data')) {
                obj['data'] = ApiClient.convertToType(data['data'], [CompanyOfferItem]);
            }
            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = Pagination.constructFromObject(data['pagination']);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/CompanyOfferItem>} data
 */
CompanyPaginatedOfferItems.prototype['data'] = undefined;

/**
 * @member {module:model/Pagination} pagination
 */
CompanyPaginatedOfferItems.prototype['pagination'] = undefined;






export default CompanyPaginatedOfferItems;

